<script setup lang="ts">
import { useFavoritesStore } from '@consumer/services/favorites/store'
import { faHeart } from '@fortawesome/pro-light-svg-icons'
import HeaderButton from '../HeaderButton.vue'

const favorites = useFavoritesStore()

onMounted(() => { favorites.loadRecentlyAddedFavorites() })

</script>

<template>
  <HeaderButton
    class="
      favorites-button
      flex items-center justify-center gap-3
      rounded-v2md border-1 border-solid border-grey-primary
      active:text-navy lg:hover:text-navy
      text-v2-tertiary
      relative
    "
    style="height: 44px; width: 44px;"
    :icon="faHeart"
    iconClass="!fill-transparent stroke-3"
    aria-label="Favorites"
  >
    <span
      v-if="!favorites.isEmpty"
      class="
        favorites-marker
        absolute
        text-xs font-semibold bg-red-500 text-white
        rounded-full h-2 w-2 flex items-center justify-center
      "
      style=" right: -2px;top: -2px;"
    />
  </HeaderButton>
</template>
